import React , { useState   } from "react";
import {  useSelector } from "react-redux";


import { useContrats } from "../../state/reactquery";
import {useUser} from '../../state/reactquery';

import { axios_jeresilie_sendLetter } from "../../axios/axios_jeresilie";

import { dateconvert } from "../../utils/utils_dates";
import {listchampsclient} from "../../utils/jeresilie";
import { useCompagniesMotifs } from "../../state/reactquery";
import ButtonSimple from "../Buttons/ButtonSimple";

import './JeResilie.scss';



const classNames = require('classnames'); 
function JeResile({closejeresile}){
    const ficheclient = useSelector(state=>state.lead.leadactu);
    const [files, setFiles] = useState([]);
    const {data: contrats} = useContrats(ficheclient?.email,ficheclient?.courtier) ; 
    const {data: user} = useUser(localStorage.getItem('token'))  ;
    const lastcontrat =  contrats?.sort((a,b)=> new Date(b.date_insert) - new Date(a.date_insert))?.[0];
    
    const {data =  { liste_compagnies: [], liste_motifs: [] }, isLoading }= useCompagniesMotifs() ;
    const liste_compagnies =data.liste_compagnies ;
    const liste_motifs =data.liste_motifs ;


    const datalead = {id_lead : ficheclient.id,courtier: ficheclient.courtier , 
                      id_client: ficheclient.id_client ,commercial : ficheclient.commercial ,
                      postmail : user.postmail , telephone: ficheclient.telephone, email: ficheclient.email}


    const initsubscriber = {"gender": (ficheclient.civilite==='M'||ficheclient.civilite==='M.')?'Monsieur':'Madame',
                            "lastname":ficheclient.nom,"firstname":ficheclient.prenom,
                            "address":ficheclient.adresse,"addressComplement": ficheclient.complement_adresse,
                            "postCode":ficheclient.code_postal,"city": ficheclient.ville,
                            "email": ficheclient.email, "country": "FRANCE"} 

    const initcontract = { "kindOfContract": 6,
                            "contractNumber":   lastcontrat?.num_contrat||"" ,
                            "cancelReason":liste_motifs?.[0]?.id,
                            "echeancePrincipale": dateconvert(ficheclient.date_effet)||(new Date()).toLocaleDateString("fr-FR") }
                      
    const [subscriber, setSubscriber] = useState(initsubscriber) ;
    const [contrat, setContrat] = useState({...initcontract}) ;
    const [recipient, setRecipient] = useState(1) ;
    const [nomcompagnie , setNomcompagnie] = useState() ;



    const changechmap =(e)=>{
        const c_contrat = e.target.id==='contractNumber'||e.target.id==='echeancePrincipale'  ||e.target.id==='nouvelAssureur' ;
        c_contrat?setContrat({...contrat,[e.target.id]: e.target.value }) :
                  setSubscriber({...subscriber,[e.target.id]: e.target.value }) ;
    }
    
    const grplabelinput = (x,label)=>( <div key={x}  className="containerinputlabelresil tiers" >
                                            <div className="inputtextelabelresil">{label}</div>
                                            <input id={x}  value={(x==="contractNumber"||x==="echeancePrincipale")?contrat[x] :subscriber[x]||''}  
                                                    type={x==='echeancePrincipale' ?"date":"text"} 
                                                    onChange={changechmap}
                                                    className="inputretractation"  />
                                        </div>) ;

    const changeSelectMotif =(e)=>{ setContrat({...contrat, "cancelReason": e.target.value})}
    const changeSelectCompagnie =(e)=>{   
        const nom_compagnie = liste_compagnies.filter(x=>x.id.toString()===e.target.value)[0]?.name  ;
        setNomcompagnie(nom_compagnie); 
        setRecipient(e.target.value) ;
    }

    const handleFile = (e) => {  setFiles(files=>[...files,...e.target.files]);};
    const clickgenderbutton = (e) => {  setSubscriber({...subscriber, 'gender': e.target.id}) ;};

    const envoiresiliation = async()=>{

        const datamandat =  {"civilite_titulaire":subscriber.gender,"prenom_titulaire":subscriber.firstname,  
                             "nom_titulaire": subscriber.lastname, "adresse": subscriber.address ,  
                            "code_postal": subscriber.postCode, "ville": subscriber.city, "compagnie": nomcompagnie, 
        }    

        const data = new FormData() ;
        data.append('datamandat', JSON.stringify(datamandat)) ; 
        data.append('datalead', JSON.stringify(datalead)) ; 
        data.append('datasubscriber', JSON.stringify(subscriber)) ; 
        data.append('datacontrat', JSON.stringify({...contrat,"cancelReason":parseInt(contrat?.cancelReason)})) ;
        data.append('recipient',recipient) ; 
        for (let i = 0; i < files.length; i++) {
                const nomfichier = files[i].name.split('.')[0] ;
                data.append('file',files[i],`/${nomfichier}.${files[i].name.split('.')[1]}`);
        }
        await axios_jeresilie_sendLetter(data) ;
        closejeresile() ; 
    }

const disablebutton = (subscriber.lastname?.trim()=='' || subscriber.firstname?.trim()=='' || subscriber.postCode?.trim()==='' || subscriber.city?.trim()==='' || subscriber.address?.trim()==='') ||
                          (contrat.contractNumber?.trim()==='' || contrat.echeancePrincipale?.trim()=='' || contrat.nouvelAssureur?.trim()==='') ;

return(<>{isLoading?<>LOADING</>:<div  className="jeresilie">
            <div className="jeresilie_btngrp" >
                <div  className="containerlabelinput"  >
                    <div className="inputtextelabelresil">Compagnies</div>
                        {<select value={recipient} className='selectcompgamme' onChange={changeSelectCompagnie} >
                                  {liste_compagnies.map((y)=><option key={y.id} id={y.id} value={y.id} >{y.name}</option>)}
                        </select>}
                </div> 
                <div  className="containerlabelinput"  >
                    <div className="inputtextelabelresil">Motifs de résiliation</div>
                        {<select value={contrat.cancelReason||''} className='selectcompgamme' onChange={changeSelectMotif} >
                                {liste_motifs.map((y)=><option key={y.id} id={y.id} value={y.id} >{y.name}</option>)}
                         </select>}
                </div> 
                <div className="gendergroup" > 
                <div  className="gendergroup_buttons" >
                    <button id='Monsieur' name="M"  className={classNames('button button_gender mr ', {'button_gender_selected': subscriber['gender']==='Monsieur'})} onClick={clickgenderbutton}>Monsieur</button>
                    <button  id='Madame'  name="Mme"  className={classNames('button button_gender', {'button_gender_selected': subscriber['gender']==='Madame'})} onClick={clickgenderbutton}>Mme / Melle</button>
                </div>
             </div>
                {Object.keys(listchampsclient).map(x=>( grplabelinput(x,listchampsclient[x]) )) }
                            
                  <div className="contratwindevis_upload">
        
                        <input type='file' multiple  id='uploaddevis' className="uploadvalidcontrat_input" 
                                 onChange={handleFile} />
                  </div>
                  <div className="groupe_boutons">
                      <ButtonSimple  texte="Fermer" containerbouton='fullbuton white' color='bouton_color_blancgris noborder' size='bouton_size_normal' onclick={closejeresile}    />   
                      <ButtonSimple  texte="Envoyer" containerbouton='fullbuton' disable={disablebutton} color='bouton_color_orange' size='bouton_size_normal' onclick={envoiresiliation}   />      
                </div>     
             
                </div>
        </div>}</>) ;
}


export default JeResile